import React from 'react';
import {
  FloatingButton as FloatingButtonNew,
  type FloatingButtonProps as FloatingButtonNewProps,
} from './FloatingButton';
import { convertOldFloatingButtonProps } from './converter.old';
import type { OldFloatingButtonProps } from './converter.old';

export type FloatingButtonProps = OldFloatingButtonProps;

// FloatingModalContainer가 cloneElement로 주입하는 내부 prop이며 old public API에는 노출하지 않는다.
type InternallyInjectedFloatingButtonProps = FloatingButtonProps & Partial<Pick<FloatingButtonNewProps, 'open'>>;

export const FloatingButton = React.forwardRef<HTMLButtonElement, FloatingButtonProps>((props, ref) => {
  const injectedOpen = (props as InternallyInjectedFloatingButtonProps).open;
  const convertedProps = convertOldFloatingButtonProps(props);

  return <FloatingButtonNew {...convertedProps} open={injectedOpen ?? convertedProps.open} ref={ref} />;
});
